<template>
  <div v-show="matchSearch">
    <group-row :group="group"
      :level="level"
      :showDropdown="showDropdown"
      :searchTerm="searchTerm"
      :searchMatchInChild="searchMatchInChild"
      @searchFound="searchFound"
      :pageType="pageType"
      @toggleDropdown="showDropdown = !showDropdown" />
    <template v-if="isUsersPage">
      <user-row v-for="user in group.users"
        :user="user"
        :group="{ name: group.name, id: group.id }"
        :level="level"
        :key="user.id"
        :searchTerm="searchTerm"
        @searchFound="searchFoundInChild"
        :hideForParent="!showDropdown"/>
      <div v-if="group.machine_users.length > 0 && showDropdown" class="divider">
        <button class="badge badge-light badge-toggle align-self-center" @click="toggleMachineUserDropdown" >
          <font-awesome-icon :icon="dropdownIcon"></font-awesome-icon>
        </button>
        <span>Machines</span>
      </div>
      <machine-user-row v-if="machineUsersVisible && showDropdown && group.machine_users.length > 0" v-for="user in group.machine_users"
        :user="user"
        :group="{ name: group.name, id: group.id }"
        :level="level"
        :key="user.id"
        :searchTerm="searchTerm"
        @searchFound="searchFoundInChild"
        :hideForParent="!machineUsersVisible"/>
    </template>
    <template v-else-if="isLicensesPage">
      <license-row v-for="pool in group.pools"
        :pool="pool"
        :group="{ name: group.name, id: group.id }"
        :level="level"
        :key="pool.id"
        :searchTerm="searchTerm"
        @searchFound="searchFoundInChild"
        :hideForParent="!showDropdown"/>
    </template>
    <recursive-rows :groups="group.children"
      :level="nextLevel"
      :searchTerm="searchTerm"
      @searchFound="searchFoundInChild"
      :pageType="pageType"
      v-show="showDropdown"/>
  </div>
</template>

<script>
import GroupRow from './GroupRow.vue';
import MachineUserRow from './MachineUserRow.vue';
import UserRow from './UserRow.vue';
import LicenseRow from './LicenseRow.vue';
import config from '../../constants/config';

export default {
  components: {
    GroupRow,
    MachineUserRow,
    UserRow,
    LicenseRow
  },
  name: 'RecursiveRow',
  props: {
    group: Object,
    level: Number,
    searchTerm: String,
    pageType: String
  },
  data() {
    return {
      showDropdown: true,
      matchSearch: true,
      searchMatchInChild: false,
      machineUsersVisible: false,
    }
  },
  methods: {
    searchFound() {
      this.matchSearch = true;
      this.showDropdown = true;
      this.$emit('searchFound');
    },
    searchFoundInChild() {
      this.searchFound();
      this.searchMatchInChild = true;
    },
    toggleMachineUserDropdown() {
      this.machineUsersVisible = !this.machineUsersVisible;
    },
  },
  computed: {
    nextLevel() {
      return this.level + 1;
    },
    isUsersPage() {
      return this.pageType == config.USERS_PAGE;
    },
    isLicensesPage() {
      return this.pageType == config.LICENSES_PAGE;
    },
    dropdownIcon() {
      return this.machineUsersVisible ? 'angle-down' : 'angle-right';
    },
  },
  watch: {
    searchTerm(newTerm) {
      this.searchMatchInChild = false;
      if (!newTerm) {
        this.matchSearch = true;
      } else {
        this.matchSearch = false;
      }
    }
  }
};
</script>
<style scoped>
.divider {
  background-color: rgba(200, 202, 203, 0.25);
  color: rgb(37, 36, 34);
  font-family: "Maven Pro";
  font-size: 14px;
  font-weight: 400;
  margin-left: -15px;
  padding-left: 50px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
